import axios from "axios";

import myConfig from "../configs/config";

function authHeaders() {
  return {
    Authorization: `Bearer ${localStorage.getItem("client-token")}`,
  };
}

export async function publishPendingServiceOrders(farmId) {
  const response = await axios.post(
    `${myConfig.API_URL}/observation/publish-pending/`,
    { farm_id: parseInt(farmId, 10) },
    { headers: authHeaders() }
  );
  return response.data;
}

export async function publishServiceOrder(observationId) {
  const response = await axios.post(
    `${myConfig.API_URL}/observation/${observationId}/publish-service-order/`,
    {},
    { headers: authHeaders() }
  );
  return response.data;
}

function normalizeAudioBlob(blob) {
  if (!blob) return null;
  let type = blob.type || "audio/webm";
  if (type === "video/webm" || type === "application/octet-stream") {
    type = "audio/webm";
  }
  if (blob.type === type) return blob;
  return new Blob([blob], { type });
}

/**
 * Anexa áudio da ordem e/ou rumo A-B após criar/editar a observação.
 * Não define Content-Type manualmente — o axios inclui o boundary do multipart.
 */
export async function uploadObservationAudio(
  observationId,
  { audioBlob, trackHeadingAudioBlob } = {}
) {
  const form = new FormData();
  if (audioBlob) {
    form.append(
      "audio_message",
      normalizeAudioBlob(audioBlob),
      `ordem-servico-${observationId}.webm`
    );
  }
  if (trackHeadingAudioBlob) {
    form.append(
      "track_heading_audio",
      normalizeAudioBlob(trackHeadingAudioBlob),
      `rumo-ab-${observationId}.webm`
    );
  }
  const response = await axios.patch(
    `${myConfig.API_URL}/observation/${observationId}/`,
    form,
    { headers: authHeaders() }
  );
  return response.data;
}

export function ordersHaveUnpublishedChanges(orders) {
  return (orders || []).some((order) => order.has_unpublished_changes);
}
